export default __webpack_public_path__ + "static/media/Times-New-Roman.f85717da.ttf";